export default __webpack_public_path__ + "static/asthait-ac10637ec9f52eae25bd24b6cfb226cc.jpg";